import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { Dialog } from '@material-ui/core'
import DialogoContactoEdit from '../../components/asignacionCupos/DialogoContactoEdit'

function OperacionesCorreos (props) {
  const { id } = props

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async () => {
    handleClose()
  }

  function onClickEliminar () {
    const result = window.confirm('¿Desea ELIMINAR el Contacto?')
    if (result) props.eliminarCorreo(id)
  }

  function onClickEditar () {
    handleOpen()
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'>
        <DialogoContactoEdit
          handleClose={handleClose}
          onSubmitContacto={handleSubmit}
          id={id} />
      </Dialog>
      <Tooltip title={'Editar Contacto'}>
        <IconButton onClick={onClickEditar}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={'Eliminar Contacto'}>
        <IconButton onClick={onClickEliminar}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

const withRedux = connect(null, actions)

export default withRedux(OperacionesCorreos)
